"use strict";

export const addMemoryWarningListener = _mmkv => {
  //no-op function, there is not a web equivalent to memory warning
};
//# sourceMappingURL=MemoryWarningListener.web.js.map